import log from "loglevel";

export * from "store/resources/about/microservice/selector";
export * from "store/resources/account/selector";
export * from "store/resources/accountUser/selector";
export * from "store/resources/aicon/selector";
export * from "store/resources/analysis/selector";
export * from "store/resources/auth/selector";
export * from "store/resources/config/selector";
export * from "store/resources/external/link/selector";
export * from "store/resources/global/selector";
export * from "store/resources/jwt/selector";
export * from "store/resources/kibana/selector";
export * from "store/resources/logstash/selector";
export * from "store/resources/rolePermissions/selector";
export * from "store/resources/team/selector";
export * from "store/resources/user/selector";
export * from "store/resources/alert/selector";

export const printEntireStore = (state: any) => {
  if (state) {
    log.info(`Store: ${JSON.stringify(state)}`);
  }
};
